import { render, staticRenderFns } from "./NoticeDetail.vue?vue&type=template&id=6df36798&"
import script from "./NoticeDetail.vue?vue&type=script&lang=js&"
export * from "./NoticeDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports